import { useEffect, useState } from 'react';

import type { MutableRefObject } from 'react';
import type React from 'react';
import type { ByfunnFrapiSearchResponse } from '../../types/frapi-types.js';

export function useKeys(
  searchResult: ByfunnFrapiSearchResponse,
  seeAllRef: React.RefObject<HTMLAnchorElement | null>,
  linkRefs: MutableRefObject<HTMLAnchorElement[]>,
  container: MutableRefObject<HTMLDivElement | null>,
) {
  const [cursor, setCursor] = useState(-1);
  const resultsLength = searchResult?.articles?.length;

  useEffect(() => {
    const keyDownHandler = (event: KeyboardEvent) => {
      const currentItem = linkRefs.current[Math.max(cursor, 0)];

      if (searchResult) {
        if (event.key === 'Enter') {
          if (cursor === -1 || cursor === resultsLength) {
            seeAllRef.current?.click();
          } else {
            currentItem.click();
          }
        }
        if (event.key === 'ArrowDown') {
          setCursor(cursor === resultsLength ? 0 : cursor + 1);
        }
        if (event.key === 'ArrowUp') {
          setCursor(cursor === 0 ? resultsLength : cursor - 1);
        }
        if (
          (event.key === 'ArrowDown' || event.key === 'ArrowUp') &&
          currentItem
        ) {
          container.current?.scrollTo({
            top: cursor * currentItem.offsetHeight,
          });
        }
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [cursor, searchResult, resultsLength]);

  return {
    cursor,
  };
}
